<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="22" height="22" />
      <p class="title-bk">生徒所属変更</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_student.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で所属を変更しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（教場ID）</th>
            <td>{{ currentSchoolDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名（コースID）</th>
            <td>{{ currentCourseDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名（クラスID）</th>
            <td>{{ currentTamaiClassDisplay }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table" v-if="hasAdminPrivilege">
        <tbody>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-0"
                  v-model="productConfirmationChecked"
                />
                <label class="custom-control-label text-danger" for="column-display-check-0">
                  生徒の所属法人・教場を変更する場合、
                  <br />
                  移動先法人・教場の利用教材（{{
                    productNamesDisplay
                  }}）に生徒の利用教材が含まれていることを確認しました。
                </label>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-1"
                  v-model="whenProductDifferentChecked"
                />
                <label class="custom-control-label text-danger" for="column-display-check-1">
                  現在、生徒の利用教材と移動先の利用教材（{{ productNamesDisplay }}）が異なる場合は、
                  <br />
                  来月からの利用教材変更予約で、移動先法人・教場の利用教材（{{
                    productNamesDisplay
                  }}）に生徒の利用教材が含まれることを確認しました。
                </label>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button
          type="button"
          class="btn-red"
          @click="confirmSaved"
          :disabled="hasAdminPrivilege && !(productConfirmationChecked && whenProductDifferentChecked)"
        >
          登録
        </button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>生徒所属変更</template>
        <template v-slot:body>生徒の所属変更が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
      <div>選択されている生徒ID数：{{ selectedStudentSize }}</div>
      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y my-custom-scrollbar">
            <b-table
              ref="student-affiliation-table"
              responsive
              sticky-header
              :items="selectedStudents"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
  basicTamaiClassNameIdPresent,
  basicProductName,
} from '@/presenters/fields';

export default {
  components: {
    PopUpHolder,
  },
  data() {
    var fields = [
      {
        key: 'uid',
        label: '生徒ID',
        sortable: true,
        thAttr: { width: 150 },
      },
      {
        key: 'name',
        label: '生徒名',
        sortable: true,
        thAttr: { width: 150 },
      },
      {
        key: 'nameKana',
        label: '生徒フリガナ',
        sortable: true,
        thAttr: { width: 150 },
      },
    ];
    return {
      fields: fields,
      currentPage: 1,
      perPage: 50,
      errorMessage: null,
      productConfirmationChecked: false,
      whenProductDifferentChecked: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (store.state.student.selectedStudents.length == 0 || store.state.student.studentAffiliation == null) {
      next({ name: 'student' });
    } else {
      next();
    }
  },
  async created() {
    await this.fetchProducts();
  },
  computed: {
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.studentAffiliation.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.studentAffiliation.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.studentAffiliation.school);
    },
    currentCourseDisplay() {
      return basicCourseNameIdPresent(this.studentAffiliation.course);
    },
    currentTamaiClassDisplay() {
      return basicTamaiClassNameIdPresent(this.studentAffiliation.tamaiClass);
    },
    selectedStudentSize() {
      return this.selectedStudents.length;
    },
    productNamesDisplay() {
      return basicProductName(this.product.products);
    },
    ...mapState({
      selectedStudents: (state) => state.student.selectedStudents,
      studentAffiliation: (state) => state.student.studentAffiliation,
    }),
    ...mapState(['product']),
    ...mapGetters('role', ['hasAdminPrivilege']),
  },
  methods: {
    confirmRevised() {
      this.$logger.debug('Need revise, go back');
      this.$router.push({ name: 'student-change-affiliation' });
    },
    confirmSaved() {
      this.$logger.debug('Finished Adding Student Affiliation: ' + JSON.stringify(this.studentAffiliation));
      this.finishEditingStudentAffiliation().then(
        (response) => {
          this.$logger.debug('Show success popup ' + response);
          this.$refs['popup_holder'].show();
        },
        (error) => {
          this.errorMessage = error;
          this.$logger.debug('Error ' + error);
        }
      );
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'student' });
    },
    ...mapActions('student', ['finishEditingStudentAffiliation']),
    ...mapActions('product', ['fetchProducts']),
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  padding-bottom: 6px;
}
.section-subtitle {
  padding-bottom: 12px;
}
form.inline-form {
  display: inline-block;
}
.btn-confirm {
  margin-left: 0px;
}
</style>
